module.exports = __webpack_public_path__ + "img/pencil-flattened.da223df.png";